import { Context } from "chartjs-plugin-datalabels";

import { IBarGraphContent, IBarItem } from "@ryde/shared";

import {
  REPORT_CHART_COMPACT_MODE_THRESHOLD,
  REPORT_CHART_LABEL_INSIDE_MIN_RATIO,
  REPORT_CHART_LABEL_MAX_LENGTH,
  REPORT_CHART_MAX_ENTITIES_DISPLAY,
  REPORT_CHART_SCROLL_CHART_PADDING,
  REPORT_CHART_SCROLL_ROW_HEIGHT,
  REPORT_CHART_TRUNCATE_LABEL_ELLIPSIS_LENGTH,
} from "./report-chart.constants";

export const sortChartEntities = ({
  content,
  maxDisplay = REPORT_CHART_MAX_ENTITIES_DISPLAY,
}: {
  content: IBarGraphContent;
  maxDisplay?: number;
}): IBarItem[] => {
  const sorted = content.entities.toSorted((a, b) => b.value - a.value);

  if (maxDisplay > 0) {
    return sorted.slice(0, maxDisplay);
  }

  return sorted;
};

export const truncateLabel = ({
  text,
  maxLength = REPORT_CHART_LABEL_MAX_LENGTH,
}: {
  text: string;
  maxLength?: number;
}): string =>
  text.length > maxLength
    ? `${text.slice(0, maxLength - REPORT_CHART_TRUNCATE_LABEL_ELLIPSIS_LENGTH)}...`
    : text;

export const isLabelInsideBar = ({
  value,
  maxValue,
}: {
  value: number;
  maxValue: number;
}): boolean =>
  maxValue > 0 &&
  value > 0 &&
  value / maxValue >= REPORT_CHART_LABEL_INSIDE_MIN_RATIO;

export const isReportChartCompactMode = ({
  barCount,
}: {
  barCount: number;
}): boolean => barCount > REPORT_CHART_COMPACT_MODE_THRESHOLD;

export const getReportChartScrollMinHeight = ({
  barCount,
}: {
  barCount: number;
}): number =>
  barCount * REPORT_CHART_SCROLL_ROW_HEIGHT + REPORT_CHART_SCROLL_CHART_PADDING;

export const shouldPlaceDataLabelInsideBar = ({
  value,
  maxValue,
  isCompactMode,
}: {
  value: number;
  maxValue: number;
  isCompactMode: boolean;
}): boolean => {
  if (isCompactMode) {
    return false;
  }

  return isLabelInsideBar({ value, maxValue });
};

export const getReportChartBarDataValue = ({
  context,
}: {
  context: Context;
}): number => Number(context.dataset.data[context.dataIndex]);

export const getReportChartLineDataLabelAnchor = ({
  isRtl,
}: {
  isRtl: boolean;
}): "end" | "start" => (isRtl ? "start" : "end");
